import { render, staticRenderFns } from "./InterAccountLeadsResultItemIcon.vue?vue&type=template&id=683ec98e&"
import script from "./InterAccountLeadsResultItemIcon.vue?vue&type=script&lang=js&"
export * from "./InterAccountLeadsResultItemIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports